import { useParams } from 'react-router-dom';
import { BaseLogisticFees } from './components/BaseLogisticFees'
import { PermitGrid } from './components/PermitGrid'
import { DesignPackageGrid } from './components/DesignPackageGrid'
import React, { useEffect, useState } from 'react';
import { useApi } from '../../../../hooks/useApi';
import { useCompanyDispatch, useCompanyState } from '../../../../stateProviders/CompanyStateProvider';
import { Box, CircularProgress } from '@mui/material';
import useIsDesignPackageEnabled from '../../../../hooks/useDesignPackageEnabled';

export const LogisticCosts = () => {

    const {companyId} = useParams();
    const api = useApi()
    const companyState = useCompanyState();
    const companyDispatch = useCompanyDispatch()
    const isDesignPackageEnabled = useIsDesignPackageEnabled();
    const [loading, setLoading] = useState(companyState.logisticCosts ? false : true)
    useEffect( () => {
        if(!companyId || companyState.logisticCosts) return
        (async () => {
            const logisticCosts = await api.logisticCosts.find({companyId})
            if(!logisticCosts) {
                setLoading(false)
                return
            }
            companyDispatch({logisticCosts})
            setLoading(false)
        })()
    },[companyId,companyState.logisticCosts])
    
    return (
        <Box
            display="flex"
            flexDirection="column"
            maxWidth={{ xs: '100%', sm: 600, md: 800, lg: 1000 }}
            gap={3}
        >
            {loading ? (
            <Box flex={1} display="flex" alignItems="center" justifyContent="center">
                <CircularProgress />
            </Box>
            ) : (
            <>
                <BaseLogisticFees />
                <PermitGrid />
                {isDesignPackageEnabled && <DesignPackageGrid />}
            </>
            )}
        </Box>
    )
}